import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingDots } from '../../ui';
import { logOut } from '../auth/authSlice'; 
import { useNavigate } from "react-router-dom";

const logoutMessages = [
  "Catch ya later—time to blast you back to the login screen!",
  "Whoops, your session's expired—sayonara, time to log out!",
  "We're kicking you out with love—back to the login lounge you go!",
  "Your VIP pass has expired—poof, you're logged out, superstar!",
  "Time's up! We're sending you to the logout dimension—zap!",
]

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const effectRan = useRef(false); 

  // Select a random message from the logoutMessages array
  const randomMessage = logoutMessages[Math.floor(Math.random() * logoutMessages.length)];

  useEffect(() => {
    // Only run the dispatch logic once, even with StrictMode
    if (effectRan.current === false || process.env.NODE_ENV !== 'development') {
      dispatch(logOut())
        .unwrap()
        .catch((error) => {
          // console.error('[Logout Component] logOut() dispatch caught an error:', error);
          // Still navigate to login even if logout action itself fails,
          // as the session might be invalid or to allow the user to retry.
        })
        .finally(() => {
          navigate('/login', { replace: true });
        });
    }

    return () => {
      // This ensures the main logic doesn't run on the StrictMode re-invocation's first run.
      if (process.env.NODE_ENV === 'development') {
        effectRan.current = true;
      }
    };
  }, [dispatch, navigate]); 

  let displayMessage = randomMessage;
  
  return (
    <LoadingDots message={displayMessage} fullContainer={true}/>
  );
}

export default Logout;
